
import { useState, useEffect } from 'react';
import { useProfile } from "@/hooks/useProfile";

interface ClassData {
  title: string;
  description: string;
  instructor: string;
  schedule: string;
  capacity: number;
  duration: number;
}

export const useClassFormState = (initialData?: ClassData) => {
  const { profile } = useProfile();
  const [title, setTitle] = useState(initialData?.title || "");
  const [description, setDescription] = useState(initialData?.description || "");
  const [instructor, setInstructor] = useState(initialData?.instructor || "");
  const [schedule, setSchedule] = useState(initialData?.schedule || "");
  const [capacity, setCapacity] = useState(initialData?.capacity || 20);
  const [duration, setDuration] = useState(initialData?.duration || 60);

  // Update form when initialData changes
  useEffect(() => {
    if (initialData) {
      setTitle(initialData.title);
      setDescription(initialData.description);
      setInstructor(initialData.instructor);
      setSchedule(initialData.schedule);
      setCapacity(initialData.capacity);
      setDuration(initialData.duration);
    }
  }, [initialData]);

  // Set instructor name for new classes (only for professors)
  useEffect(() => {
    if (!initialData && !instructor && profile?.first_name && profile?.last_name && profile?.role === 'profesor') {
      setInstructor(`${profile.first_name} ${profile.last_name}`);
    }
  }, [profile, initialData, instructor]);

  // Validation function for schedule
  const validateSchedule = (scheduleString: string): boolean => {
    if (!scheduleString) return false;
    
    // Check if it has proper time format
    const timePattern = /\d{2}:\d{2}-\d{2}:\d{2}/;
    return timePattern.test(scheduleString);
  };

  return {
    title,
    setTitle,
    description,
    setDescription,
    instructor,
    setInstructor,
    schedule,
    setSchedule,
    capacity,
    setCapacity,
    duration,
    setDuration,
    profile,
    validateSchedule
  };
};
